import React from "react";
import Hero from "../components/Hero";
import ClientLogos from "../components/ClientLogos";
import Solutions from "../components/Solutions";
import Features from "../components/Features";
import Industries from "../components/Industries";
import VideoDemo from "../components/VideoDemo";
import Integrations from "../components/Integrations";
import CaseStudies from "../components/CaseStudies";
import Testimonials from "../components/Testimonials";
import Pricing from "../components/Pricing";
import DemoForm from "../components/DemoForm";
import SEO from "../components/SEO";
import { getPageSeo, serviceSchema } from "../lib/seo";

const Home = () => {
  return (
    <>
      <SEO {...getPageSeo("/")} schema={serviceSchema()} />
      <Hero />
      <ClientLogos />
      <Solutions />
      <Features />
      <VideoDemo />
      <Industries />
      <Integrations />
      <CaseStudies />
      <Testimonials />
      <Pricing />
      <DemoForm />
    </>
  );
};

export default Home;
